import request from '@/utils/request'
export const listSearchRecords=params=>request({url:'/dkmall/search/records',method:'get',params})
export const listHotSearch=params=>request({url:'/dkmall/search/hot',method:'get',params})
export const saveHotSearch=data=>request({url:'/dkmall/search/hot',method:'post',data})
export const setHotSearchStatus=(keyword,region,enabled)=>request({url:'/dkmall/search/hot/status',method:'put',params:{keyword,region,enabled}})
export const removeHotSearch=(keyword,region)=>request({url:'/dkmall/search/hot',method:'delete',params:{keyword,region}})
